<template>
    <div class="quick-notification-item d-flex flex-row p-2">
        <div class="d-flex justify-content-center" style="width: 4rem">
            <img
                style="width: 3.5rem; height: 3.5rem"
                :src="`/icon/notification/${element.notificationId}.svg`"
            />
        </div>
        <div
            class="d-flex flex-column flex-fill"
            style="width: 1%; margin-left: 0.5rem"
        >
            <div>
                <span>Thank you for using our service. You used</span>
                <span
                    v-if="element.billingIrenderPoint"
                    style="font-weight: 500"
                >
                    &nbsp;{{ element.billingIrenderPoint }}&nbsp;iRp&nbsp;
                </span>
                <span
                    v-if="
                        element.billingIrenderPoint && element.billingBonusPoint
                    "
                    >and</span
                >
                <span v-if="element.billingBonusPoint" style="font-weight: 500">
                    &nbsp;{{ element.billingBonusPoint }}&nbsp;Bp&nbsp;
                </span>
                <span>with machine</span>
                <span style="font-weight: 500">
                    &nbsp;#{{ element.machineId }}&nbsp;
                </span>
                <span>for</span>
                <span style="font-weight: 500">
                    &nbsp;{{ element.billingDuration }}&nbsp;
                </span>
            </div>
            <div style="font-size: 0.8rem; color: #42a5f5">
                {{ element.createdAt | pretyDateUtcToLocal }}
            </div>
            <div class="mt-2 mb-1">
                <el-button
                    v-if="!element.rated"
                    @click="goToRateImage"
                    style="font-family: Montserrat; width: 7.5rem"
                    size="small"
                    type="primary"
                    >Rate it</el-button
                >
                <el-button
                    @click="goToDetailBilling"
                    :title="`Billing ID :${element.billingCode}`"
                    style="font-family: Montserrat; width: 7.5rem"
                    size="small"
                    >Billing</el-button
                >
            </div>
        </div>
        <div
            v-if="!element.read"
            class="d-flex flex-row align-items-center justify-content-center ml-1 mr-1"
        >
            <div
                style="
                    height: 12px;
                    width: 12px;
                    border-radius: 1rem;
                    background-color: forestgreen;
                "
            ></div>
        </div>
    </div>
</template>

<script>
// Event, Dialog
import EventBus from "@/event/EventBus";

// Extend
import baseNotificationsService from "@/scripts/notifications/baseNotificationsService";

// Constant
import { POPUP_ID } from "@/constant/baseConstant";

export default {
    extends: baseNotificationsService,

    props: {
        element: {
            type: Object,
            default: null,
        },
    },

    methods: {
        //#region Go to rate image
        goToRateImage() {
            this.$root.$emit("bv::hide::popover");
            EventBus.$emit("processingEventApp", {
                event: "processOpenPopup",
                data: {
                    type: POPUP_ID.RATE_IMAGE,
                    data: this.element,
                },
            });
            this.markStatus(this.element.id);
            this.$emit("onGoToRateImage");
        },
        //#endregion

        //#region Go to detail billing
        goToDetailBilling() {
            this.$root.$emit("bv::hide::popover");
            this.pushUrl(this.routeUrl.BILLING_HISTORY);
            this.markStatus(this.element.id);
            this.$emit("onGoToDetailBilling");
        },
        //#endregion
    },
};
</script>